import { useQuery } from "@tanstack/react-query";

import { useAppState } from "../context/StateContext";
import ProjectService from "../services/project.service";
import { Status } from "../util/enums";
import { ProjectKeys } from "../util/queries";

const CACHE_TIME = 60 * 60 * 1000; // 1 hour
const STALE_TIME = 5 * 60 * 1000; // 5 minutes

export const useActionProject = () => {
  const { currentUser } = useAppState();
  const getAllActiveProjects = () => {
    return useQuery({
      queryKey: ProjectKeys.getAll([]),
      queryFn: async () => {
        const response = await ProjectService.getAll({
          sortBy: JSON.stringify([["name", "ASC"]]),
          include: JSON.stringify([
            { association: "userProjects", where: { userId: currentUser?.id } },
          ]),
          status: Status.ACTIVE,
        });

        if (response?.data) {
          return response?.data;
        }

        return [];
      },
      enabled: !!currentUser?.id,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
    });
  };

  return {
    getAllActiveProjects,
  };
};
